import httpClient from "./httpClient";

const base = "/class-configurations";

export function listClassConfigurations() {
  return httpClient.get(base).then((res) => res.data.data);
}

export function createClassConfiguration(payload) {
  return httpClient.post(base, payload).then((res) => res.data.data);
}

export function deleteClassConfiguration(id) {
  return httpClient.delete(`${base}/${id}`).then((res) => res.data);
}
